import React from 'react';

export const CommentsIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.25 4C4.17893 4 2.5 5.67893 2.5 7.75V14.25C2.5 16.3211 4.17893 18 6.25 18H6.5V21.5029C6.5 21.9483 7.03857 22.1714 7.35355 21.8564L11.21 18H18.75C20.8211 18 22.5 16.3211 22.5 14.25V7.75C22.5 5.67893 20.8211 4 18.75 4H6.25Z"
			fill="#BAC5D5"
		/>
	</svg>
);
